import React from "react";
import { Button, ButtonProps } from "react-bootstrap";
import Btn  from './Button';

export interface SaveButtonProps extends ButtonProps {
    text?: string
    onClick?: (event: React.MouseEvent<HTMLElement>) => void
    variant?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'danger'
    | 'warning'
    | 'info'
    | 'dark'
    | 'light'
    | 'link'
    | 'outline-primary'
    | 'outline-secondary'
    | 'outline-success'
    | 'outline-danger'
    | 'outline-warning'
    | 'outline-info'
    | 'outline-dark'
    | 'outline-light'
}

const SaveButton: React.FC<SaveButtonProps> = ({ text, variant, disabled, onClick }) => {

    if (!text) text = 'Save'
    if (!variant) variant = 'secondary'

    return (
        <Btn text={text} fill variant={variant} disabled={disabled} onClick={onClick} />
    );
}
export default SaveButton;